// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"4e1f7aa2","631":"fd57e9e9","774":"2a4d35c4","787":"2e3ea13a","858":"cb511c75"}[chunkId] + ".chunk.js";
};